import normaliseElementTopValue from 'src/js/modules/highlighter/helpers/normalise-element-top-value';

const getElementBoundsForHighlighter = (element, scrollTop) => {
  const { height, width, left, top } = element.getBoundingClientRect();

  const elementTop = normaliseElementTopValue({ element, top, scrollTop });
  const highlighterTop = elementTop + scrollTop;

  return {
    width,
    height,
    left,
    top: highlighterTop,
  };
};

export default getElementBoundsForHighlighter;
